import React, { useState } from "react";
import { Play, X, CheckCircle2, Users, TrendingUp } from 'lucide-react';

import { TwinneeLogo } from '@/components/TwinneeLogo';
export const ShowcaseSection = () => {
  const [activeVideo, setActiveVideo] = useState(null);
  const pub = process.env.PUBLIC_URL || "";

  const showcaseItems = [
    { id: 1, title: "Wedding", subtitle: "Twin", singleLineTitle: "Wedding Twin", image: `${pub}/LandingPageAssets/1.png`, colorGradient: "from-[#ff2e54]/55 via-[#be123c]/40 to-[#0a0507]/90", activeBorder: "border-white/10 hover:border-white/25" },
    { id: 2, title: "Action Hero", singleLineTitle: "Action Hero", image: `${pub}/LandingPageAssets/2.png`, colorGradient: "from-[#2563eb]/50 via-[#1d4ed8]/40 to-[#050b14]/90", activeBorder: "border-[#6366f1]/60 shadow-[0_0_25px_rgba(99,102,241,0.25)]" },
    { id: 3, title: "Comedy Skit", singleLineTitle: "Comedy Skit", image: `${pub}/LandingPageAssets/3.png`, colorGradient: "from-[#f59e0b]/45 via-[#b45309]/35 to-[#0e0904]/90", activeBorder: "border-white/10 hover:border-white/25" },
    { id: 4, title: "Festival Reel", singleLineTitle: "Festival Reel", image: `${pub}/LandingPageAssets/4.png`, colorGradient: "from-[#10b981]/45 via-[#047857]/35 to-[#040e0b]/90", activeBorder: "border-white/10 hover:border-white/25" },
  ];

  return (
    <section id="showcase" className="text-white py-24 px-4 sm:px-6 lg:px-8 font-sora relative overflow-hidden">
      <div className="absolute top-1/3 -left-20 w-[500px] h-[500px] rounded-full pointer-events-none z-0" style={{ background: "radial-gradient(circle at center, rgba(98,250,227,0.12) 0%, transparent 65%)", filter: "blur(50px)" }} />
      <div className="absolute top-1/4 -right-20 w-[500px] h-[500px] rounded-full pointer-events-none z-0" style={{ background: "radial-gradient(circle at center, rgba(208,188,255,0.12) 0%, transparent 65%)", filter: "blur(50px)" }} />

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <p className="text-xs font-semibold tracking-widest text-[#62FAE3] uppercase mb-3 font-mono">REAL VIDEOS, REAL PEOPLE</p>
          <h2 className="text-4xl sm:text-5xl lg:text-[54px] font-bold tracking-tight leading-[1.15] text-white">
            See What People Like You<br /><span className="text-[#62FAE3]">Have Made</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {showcaseItems.map((item) => (
            <div key={item.id} onClick={() => setActiveVideo(item)} className={`relative h-[380px] sm:h-[420px] rounded-[22px] overflow-hidden border ${item.activeBorder} bg-[#0a0d14] flex flex-col justify-between p-6 cursor-pointer group transition-all duration-300 shadow-2xl hover:scale-[1.02]`}>
              <img src={item.image} alt={item.singleLineTitle} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className={`absolute inset-0 bg-gradient-to-b ${item.colorGradient} mix-blend-multiply opacity-90 group-hover:opacity-80 transition-opacity duration-300`} />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-black/20" />
              <div className="relative z-10" />
              <div className="relative z-10 self-center">
                <div className="w-12 h-12 rounded-full bg-white text-black flex items-center justify-center shadow-2xl group-hover:scale-110 group-active:scale-95 transition-all duration-300">
                  <Play className="w-5 h-5 fill-current ml-0.5" />
                </div>
              </div>
              <div className="relative z-10 text-left">
                <h3 className="text-xl font-bold text-white tracking-tight leading-snug">{item.title}{item.subtitle && <><br />{item.subtitle}</>}</h3>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-center gap-6 sm:gap-10 text-xs text-gray-400 font-medium font-mono">
          <div className="flex items-center gap-2"><CheckCircle2 className="w-4 h-4 text-[#62FAE3]" /><span>1.2M+ Videos Created</span></div>
          <div className="flex items-center gap-2"><Users className="w-4 h-4 text-[#62FAE3]" /><span>500k Active Creators</span></div>
          <div className="flex items-center gap-2"><TrendingUp className="w-4 h-4 text-[#62FAE3]" /><span>Trending in 40+ Countries</span></div>
        </div>
      </div>

      {activeVideo && (
        <div className="fixed inset-0 z-50 bg-black/90 backdrop-blur-md flex items-center justify-center p-4">
          <div className="relative w-full max-w-3xl rounded-3xl border border-white/20 bg-[#0c0f17] p-6 shadow-2xl">
            <button onClick={() => setActiveVideo(null)} className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white cursor-pointer"><X className="w-5 h-5" /></button>
            <div className="aspect-video w-full rounded-2xl bg-black relative overflow-hidden border border-white/10 mb-4">
              <img src={activeVideo.image} alt={activeVideo.singleLineTitle} className="w-full h-full object-cover opacity-80" />
              <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/40 text-center p-6">
                <TwinneeLogo className="w-12 h-12 text-[#62FAE3] mb-3 animate-pulse" />
                <h4 className="text-xl font-bold text-white mb-2">{activeVideo.singleLineTitle}</h4>
                <p className="text-xs text-gray-300">Generated scene preview ready for editor playback.</p>
              </div>
            </div>
            <div className="flex items-center justify-between text-sm">
              <div><h3 className="font-bold text-white">{activeVideo.singleLineTitle}</h3><p className="text-xs text-gray-400">Community Production</p></div>
              <a href="/register" className="px-5 py-2.5 rounded-full bg-[#62FAE3] text-[#05070a] font-bold text-xs hover:brightness-110">Create Similar Cut →</a>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ShowcaseSection;
